import { render, staticRenderFns } from "./LabTemplate.vue?vue&type=template&id=5320aaf5"
import script from "./LabTemplate.vue?vue&type=script&lang=js"
export * from "./LabTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports